import { beastStatusAtom } from '@realtime';
import { useAtomValue } from 'jotai';

import { ElvaLogoName, typography } from '@ui';

import { statusLabelAtom } from '../../store/status';

import * as css from './styles.css';

export const VideoStatus = () => {
    const statusLabel = useAtomValue(statusLabelAtom);
    const status = useAtomValue(beastStatusAtom) === 'BALL_STEADY' ? 'ready' : 'waiting';
    return (
        <div className={css.sideBoxes}>
            <div className={css.statusBox}>
                <div className={css.statusDot({ status })}></div>
                <p
                    className={typography({
                        variant: 'pLarge',
                        weight: 'bold',
                    })}
                >
                    {statusLabel}
                </p>
            </div>
            <div className={css.logoBox}>
                <ElvaLogoName width={300} textColor="white" />
            </div>
        </div>
    );
};
